import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvModeratorAppPersistence = new MMKV({
  id: MMKVStoreKeyMap.moderatorAppSettings,
});

export const zustandModeratorAppStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvModeratorAppPersistence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvModeratorAppPersistence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvModeratorAppPersistence.delete(name);
  },
};
